import { QcStatusOption } from '../SeparationWorklist/types';

/** QC values for PUT /brazil/section_mapping (page-details status). */
const PAGE_MAPPING_QC_OPTIONS: QcStatusOption[] = [
  { label: 'To QC', value: 'to_qc' },
  { label: 'QCed', value: 'qced' }
];

export default PAGE_MAPPING_QC_OPTIONS;
